import { render } from "./Modal.vue?vue&type=template&id=4fa69ddf"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=4fa69ddf&lang=css"
script.render = render

export default script